import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { ICourse } from "../../../Pages/Subject/ICourse";

export const ListCourseSlice = createSlice({
  name: "ListCourseSlice",
  initialState: {} as IReduxState<ICourse[]>,
  reducers: {
    listCourse: (state) => {
      state.isLoading = true;
    },
    successlistCourse: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failurelistCourse: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
  },
});

export const { failurelistCourse, listCourse, successlistCourse } = ListCourseSlice.actions;

export default ListCourseSlice.reducer;
